import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Sparkles, X, Check, Loader2, Zap } from "lucide-react";

const PROPLUS_FEATURES = [
  "Importar y exportar BC3 (FIEBDC-3)",
  "OCR con Claude Vision (facturas y tickets)",
  "Contabilidad: ingresos, gastos, libros",
  "Facturación electrónica Verifactu",
  "Análisis IA de precios obsoletos",
];

export default function UpgradeProModal() {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setReason(e.detail?.detail || "");
      setOpen(true);
    };
    window.addEventListener("app:upgrade-required", handler);
    return () => window.removeEventListener("app:upgrade-required", handler);
  }, []);

  const subscribeProPlus = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/billing/checkout", { plan: "proplus" });
      window.location.href = data.url;
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error iniciando checkout");
      setLoading(false);
    }
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4" onClick={() => !loading && setOpen(false)} data-testid="upgrade-pro-modal">
      <div className="bg-white max-w-lg w-full overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="bg-slate-900 text-white p-6 relative">
          <button
            onClick={() => !loading && setOpen(false)}
            className="absolute top-3 right-3 p-2 hover:bg-white/10"
            data-testid="upgrade-modal-close"
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
          <div className="inline-flex items-center gap-1 px-2 py-0.5 bg-orange-600 text-[10px] font-bold uppercase tracking-widest mb-3">
            <Zap className="w-3 h-3" /> Función PRO
          </div>
          <h2 className="font-display font-extrabold text-2xl sm:text-3xl">Sube al plan PRO para usar esta función</h2>
          <p className="text-slate-300 mt-2 text-sm">
            {reason || "Esta función requiere el plan PRO (BC3, OCR, Verifactu, Contabilidad)."}
          </p>
        </div>
        <div className="p-6">
          <div className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2">Lo que desbloqueas</div>
          <ul className="space-y-2 mb-5">
            {PROPLUS_FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-2 text-sm">
                <Check className="w-4 h-4 text-orange-600 flex-shrink-0 mt-0.5" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <div className="bg-slate-50 border border-slate-200 p-4 mb-4">
            <div className="flex items-baseline gap-2">
              <div className="font-display font-extrabold text-3xl tabular-nums">39 €</div>
              <div className="text-slate-500 text-sm">/mes</div>
              <div className="ml-auto text-xs text-orange-700 font-bold">Sólo 10 € más que el plan Básico</div>
            </div>
            <div className="text-xs text-slate-500 mt-1">14 días gratis · Sin permanencia · Cancela cuando quieras</div>
          </div>
          <button
            onClick={subscribeProPlus}
            disabled={loading}
            data-testid="upgrade-modal-cta"
            className="w-full h-12 bg-orange-600 text-white font-bold hover:bg-orange-700 inline-flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading ? <><Loader2 className="w-5 h-5 animate-spin" /> Cargando…</> : (
              <><Sparkles className="w-5 h-5" /> Cambiar a PRO ahora</>
            )}
          </button>
          <button
            onClick={() => !loading && setOpen(false)}
            className="w-full mt-2 h-10 text-sm text-slate-500 hover:text-slate-900"
            data-testid="upgrade-modal-later"
          >
            Quizá más tarde
          </button>
        </div>
      </div>
    </div>
  );
}
